import { render, staticRenderFns } from "./AlertasBarredores.vue?vue&type=template&id=198a6f22&scoped=true"
import script from "./AlertasBarredores.vue?vue&type=script&lang=ts"
export * from "./AlertasBarredores.vue?vue&type=script&lang=ts"
import style0 from "./AlertasBarredores.vue?vue&type=style&index=0&id=198a6f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a6f22",
  null
  
)

export default component.exports